
export const isUpperCase = (value) => /[A-Z]/.test(value);

export const isLowerCase = (value) => /[a-z]/.test(value);

export const isContainNumber = (value) => /\d/.test(value);

export const isSpecialChar = (value) =>
  /[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+/.test(value);
